// extracted by mini-css-extract-plugin
export default {"button":"AppButton_button__LshHX"};